export const SET_FILTER_CATEGOTY = 'SET_FILTER_CATEGOTY',
    SET_FILTER_START_DATE = 'SET_FILTER_START_DATE',
    SET_FILTER_END_DATE = 'SET_FILTER_END_DATE',
    UPDATE_USER_ACTIVITIES = 'UPDATE_USER_ACTIVITIES',
    RESET_ACTIVITY_FILTER = 'RESET_ACTIVITY_FILTER';


